var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M9.35547 7H4.35547V17H9.35547V7ZM3.35547 6V18H10.3555V6H3.35547Z","key":0}),React.createElement("path",{"fill":"currentColor","d":"M15.3555 7H10.3555V17H15.3555V7ZM9.35547 6V18H16.3555V6H9.35547Z","key":1}),React.createElement("path",{"fill":"currentColor","d":"M21.3555 7H16.3555V17H21.3555V7ZM15.3555 6V18H22.3555V6H15.3555Z","key":2})]);
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
